// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad = require("../Control.Monad/index.js");
var Control_Monad_Rec_Class = require("../Control.Monad.Rec.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Bounded = require("../Data.Bounded/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Effect = require("../Effect/index.js");
var Effect_Random = require("../Effect.Random/index.js");
var Extra_Prelude = require("../Extra.Prelude/index.js");
var Random_Blob = require("../Random.Blob/index.js");
var Gen = function (x) {
    return x;
};
var Random = function (x) {
    return x;
};
var unsafeIndex = function (ifCrash) {
    return function (a) {
        return function (i) {
            var v = Data_Array.index(a)(i);
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Extra_Prelude.impossible(ifCrash);
            };
            throw new Error("Failed pattern match at Random.Gen (line 107, column 27 - line 109, column 32): " + [ v.constructor.name ]);
        };
    };
};
var split = function (v) {
    var b0 = Random_Blob.merge(v)(v);
    var b1 = Random_Blob.merge(b0)(v);
    var b2 = Random_Blob.merge(v)(b0);
    return {
        one: b1,
        two: b2
    };
};
var nextBlob = Random(function (v) {
    return {
        result: v,
        nextGen: Gen(Random_Blob.perturb(v))
    };
});
var newtypeRandom = new Data_Newtype.Newtype(function (n) {
    return n;
}, Random);
var runRandom = Data_Newtype.un(newtypeRandom)(Random);
var runRandom$prime = function (r) {
    return function (g) {
        return (function (v) {
            return v.result;
        })(runRandom(r)(g));
    };
};
var newGen = Data_Functor.map(Effect.functorEffect)(function ($51) {
    return Gen(Random_Blob.fromInts($51));
})(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Data_Functor.map(Effect.functorEffect)(Random_Blob.Ints.create)(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))))(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))))(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))))(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))))(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))))(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))))(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))))(Effect_Random.randomInt(Data_Bounded.bottom(Data_Bounded.boundedInt))(Data_Bounded.top(Data_Bounded.boundedInt))));
var runRandomEffect = function (r) {
    return function __do() {
        var g = newGen();
        return runRandom$prime(r)(g);
    };
};
var functorRandom = new Data_Functor.Functor(function (f) {
    return function (v) {
        return Random(function (gen) {
            var x = v(gen);
            return {
                result: f(x.result),
                nextGen: x.nextGen
            };
        });
    };
});
var next = Data_Functor["void"](functorRandom)(nextBlob);
var nextDoubles = Data_Functor.map(functorRandom)(Random_Blob.toDoubles)(nextBlob);
var nextDouble = (function () {
    var firstDouble = function (v) {
        return v.value0;
    };
    return Data_Functor.map(functorRandom)(firstDouble)(nextDoubles);
})();
var nextInts = Data_Functor.map(functorRandom)(Random_Blob.toInts)(nextBlob);
var nextInt = (function () {
    var firstInt = function (v) {
        return v.value0;
    };
    return Data_Functor.map(functorRandom)(firstInt)(nextInts);
})();
var intRange = function (low) {
    return function (high) {
        return Data_Function.flip(Data_Functor.map(functorRandom))(nextInt)(function (i) {
            return Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(i)((high - low | 0) + 1 | 0) + low | 0;
        });
    };
};
var unsafeElement = function (ifCrash) {
    return function (arr) {
        return Data_Functor.map(functorRandom)(unsafeIndex(ifCrash)(arr))(intRange(0)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(arr) - 1 | 0));
    };
};
var element = (function () {
    var $52 = unsafeElement("it was nonempty!");
    return function ($53) {
        return $52(Data_Array_NonEmpty.toArray($53));
    };
})();
var chance = function (p) {
    return Data_Functor.map(functorRandom)(Data_Ord.greaterThanOrEq(Data_Ord.ordInt)(p))(intRange(1)(100));
};
var branch = Random(function (gen) {
    var v = split(gen);
    return {
        result: v.one,
        nextGen: v.two
    };
});
var monadRandom = new Control_Monad.Monad(function () {
    return applicativeRandom;
}, function () {
    return bindRandom;
});
var bindRandom = new Control_Bind.Bind(function () {
    return applyRandom;
}, function (v) {
    return function (f) {
        return Random(function (gen) {
            var r = v(gen);
            return runRandom(f(r.result))(r.nextGen);
        });
    };
});
var applyRandom = new Control_Apply.Apply(function () {
    return functorRandom;
}, Control_Monad.ap(monadRandom));
var applicativeRandom = new Control_Applicative.Applicative(function () {
    return applyRandom;
}, function (x) {
    return Random(function (gen) {
        return {
            result: x,
            nextGen: gen
        };
    });
});
var monadRecRandom = new Control_Monad_Rec_Class.MonadRec(function () {
    return monadRandom;
}, function (stepM) {
    return function (seed) {
        var step = function (v) {
            var v1 = runRandom(stepM(v.value))(v.gen);
            if (v1.result instanceof Control_Monad_Rec_Class.Done) {
                return new Control_Monad_Rec_Class.Done({
                    nextGen: v1.nextGen,
                    result: v1.result.value0
                });
            };
            if (v1.result instanceof Control_Monad_Rec_Class.Loop) {
                return new Control_Monad_Rec_Class.Loop({
                    gen: v1.nextGen,
                    value: v1.result.value0
                });
            };
            throw new Error("Failed pattern match at Random.Gen (line 154, column 11 - line 156, column 52): " + [ v1.result.constructor.name ]);
        };
        return function (gen) {
            return Control_Monad_Rec_Class.tailRec(step)({
                gen: gen,
                value: seed
            });
        };
    };
});
var unsafeWeightedElement = function (ifCrash) {
    return function (weight) {
        return function (xs) {
            var cumWeights = Data_Traversable.scanl(Data_Traversable.traversableArray)(function (cumWeight) {
                return function (x) {
                    return cumWeight + weight(x) | 0;
                };
            })(0)(xs);
            return Control_Bind.bind(bindRandom)(intRange(0)(Data_Maybe.fromJust()(Data_Array.last(cumWeights)) - 1 | 0))(function (w) {
                var i = Data_Maybe.fromJust()(Data_Array.findIndex(function (cw) {
                    return cw > w;
                })(cumWeights));
                return Control_Applicative.pure(applicativeRandom)(unsafeIndex(ifCrash)(xs)(i));
            });
        };
    };
};
module.exports = {
    Random: Random,
    branch: branch,
    chance: chance,
    element: element,
    intRange: intRange,
    newGen: newGen,
    next: next,
    nextDouble: nextDouble,
    nextDoubles: nextDoubles,
    nextInt: nextInt,
    nextInts: nextInts,
    runRandom: runRandom,
    "runRandom'": runRandom$prime,
    runRandomEffect: runRandomEffect,
    split: split,
    unsafeElement: unsafeElement,
    unsafeWeightedElement: unsafeWeightedElement,
    functorRandom: functorRandom,
    newtypeRandom: newtypeRandom,
    applyRandom: applyRandom,
    applicativeRandom: applicativeRandom,
    bindRandom: bindRandom,
    monadRandom: monadRandom,
    monadRecRandom: monadRecRandom
};
